import type { OptionTypeBase, Props as ReactSelectProps } from 'react-select';

import {
  IconButton,
  type IconButtonProps,
  TagIcon,
} from '@frontend/components';
import { CloseIcon } from '@frontend/components/src/components/mediaAndIcons/icons/iconSet';

import { useSelectStyles } from '../SelectStylesContext';

export interface MultiValueRemoveProps<
  OptionType extends OptionTypeBase,
  IsMulti extends boolean,
> {
  innerProps: IconButtonProps;
  selectProps: ReactSelectProps<OptionType, IsMulti>;
}

export const MultiValueRemove = <
  OptionType extends OptionTypeBase,
  IsMulti extends boolean,
>({
  innerProps,
  selectProps,
}: MultiValueRemoveProps<OptionType, IsMulti>) => {
  const styles = useSelectStyles();

  return (
    <IconButton
      data-sub-action-type="destructive"
      __css={styles.multiValueRemove}
      {...innerProps}
      tabIndex={-1}
    >
      <TagIcon
        padding={selectProps.size === 'sm' ? 'px' : 0.25}
        as={CloseIcon}
      />
    </IconButton>
  );
};
